<template>
<div class="cloud_breadcrumb" aria-label="Breadcrumb" role="navigation">
    <BreadcrumbItem
      v-if="
        metadata.productType == 'CLOUD_FILE' ||
          metadata.productType == 'CLOUD_DOCUMENT'
      "
      :key="metadata.productType"
    >
      <a
        :style="
          metadata.productType == 'CLOUD_FILE' ? { cursor: 'not-allowed' } : {}
        "
        class="active"
        @click="handleOpenHome"
      >
        <span>{{ this.fileContent[metadata.productType] }}</span>
      </a>
    </BreadcrumbItem>
    <BreadcrumbItem
      v-for="(item, index) of showRouteItems"
      :key="index"
      :isLastItem="index === showRouteItems.length - 1"
    >
      <a
        :style="disabledLinkStyle(item, index)"
        class="active"
        @click="gotoRoute(item, index)"
      >
        <moo-popover
          popper-class="cloud_breadcrumb_popover"
          placement="top-start"
          width="422"
          trigger="hover"
          v-if="item.placeholder"
        >
          <BreadCrumbDropList
            :dropList="hideRouteItems"
            @clickItem="gotoRoute"
          ></BreadCrumbDropList>
          <svg-icon
            class="file-separator"
            icon-class="file-path-more"
            slot="reference"
          />
        </moo-popover>
        <span v-else>{{ item.fileName }}</span>
      </a>
    </BreadcrumbItem>

    <div v-if="is_inTocaApp" class="breadcrumb_cover"></div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import BreadcrumbItem from "./BreadCrumbItem.vue";
import BreadCrumbDropList from "./BreadCrumbDropList.vue";
import { debounce } from "@/utils/lodash";

export default {
  name: "BreadCrumb",
  props: {
    isMettingDoc: {
      type: Boolean,
      default: false
    },
    metadata: {
      type: Object,
      default: () => {}
    },
    separator: {
      type: String,
      default: "/"
    },
    separatorClass: {
      type: String,
      default: ""
    },
    routeItems: {
      type: Array,
      default: () => []
    },
    isWiki: {
      type: Boolean,
      default: false
    },
    spaceId: {
      type: String,
      default: ""
    },
    userId: {
      type: String,
      default: ""
    }
  },
  components: {
    BreadcrumbItem,
    BreadCrumbDropList
  },
  data() {
    return {
      breadMoreIconHovered: false,
      breadcrumbWidthObserver: null,
      breadCrumbContainerWidth: 0,
      showRouteItems: [],
      fileContent: {
        CLOUD_FILE: intl.$t("云盘#!!!#src/pages/H5/Cloud/components/breadCrumb/breadCrumb.vue_1"),
        CLOUD_DOCUMENT: intl.$t("云文档#!!!#src/pages/H5/Cloud/components/breadCrumb/breadCrumb.vue_1")
      }
    };
  },
  provide() {
    return {
      elBreadcrumb: this
    };
  },
  computed: {
    is_inTocaApp() {
      return navigator.userAgent.toLowerCase().indexOf("toca") !== -1;
    },
    hideRouteItems() {
      let hideItems = [];
      let showItemIds = [];
      for (let i = 0; i < this.showRouteItems.length; i++) {
        let item = this.showRouteItems[i];
        if (item?.placeholder === false) {
          showItemIds.push(item.fileId);
        }
      }
      hideItems = this.routeItems.filter((item) => {
        return !showItemIds.includes(item.fileId);
      });
      return hideItems;
    },
    disabledLinkStyle() {
      return (item, index) => {
        if (item.fileUrl) {
          return {};
        } else {
          return {
            cursor: "not-allowed"
          };
        }
      };
    }
  },
  methods: {
    handleOpenHome() {
      if (this.metadata.productType == "CLOUD_DOCUMENT") {
        window.open(`https:${process.env.VUE_APP_WIKI_URL}`, "_blank");
      }
    },
    gotoRoute(item, index) {
      if (item.placeholder) return;
      if (this.isWiki) {
        window.parent.postMessage(
          {
            type: "gotoFile",
            fileId: item?.fileId //要跳转到知识库文件id
          },
          "*"
        );
      } else {
        if (item.fileUrl) {
          window.open(item.fileUrl, "_blank");
        } else {
          return;
        }
        // const ownId = this.spaceId + "_" + this.userId + "_doc";
        // if (item.fileId === ownId) {
        //     window.open(`https:${process.env.VUE_APP_BASE_URL}/cloud-home#my`, '_blank');
        // } else {
        //     if (index == 0) { return }
        //     const { origin, pathname } = window.location;
        //     var openUrl = origin + pathname + `?fid=${item?.fileId}`;
        //     if (pathname == "/web/file") {
        //         openUrl = origin + pathname + `#/?fid=${item?.fileId}`;
        //     }
        //     window.open(openUrl);
        // }
      }
    },
    computeFontSize(text) {
      const dom = document.createElement("span");
      dom.style.fontSize = "12px";
      dom.style.opacity = "0";
      dom.innerText = text;
      document.body.append(dom);
      const width = dom.offsetWidth;
      dom.remove();
      return width;
    },
    observeBreadCrumbWidth() {
      let breadEL = document.querySelector(".header-crumb");
      const resizeCallBack = (entries) => {
        for (let entry of entries) {
          this.breadCrumbContainerWidth = entry.contentRect.width - 20;
          let copyedRouteItems = this.routeItems.map((item) => {
            return { ...item };
          });
          if (entry.contentRect.width > 0) {
            requestAnimationFrame(() => {
              this.showRouteItems = this.computeSelectItems(copyedRouteItems);
            });
          }
        }
      };
      this.breadcrumbWidthObserver = new ResizeObserver(
        debounce(resizeCallBack, 200)
      );
      if (breadEL && this.breadcrumbWidthObserver) {
        this.breadcrumbWidthObserver.observe(breadEL);
      }
    },
    // computeSelectItems(items) {
    //     const width = this.getSelectItemWidth(items);
    //     console.log(
    //         "width is",
    //         width,
    //         "&& breadCrumbContainerWidth",
    //         this.breadCrumbContainerWidth
    //     );
    //     if (width <= this.breadCrumbContainerWidth) {
    //         console.log("result is", items);
    //         return items;
    //     }
    //     if (items.length === 2) {
    //         let length = items[1].fileName.length;
    //         items[1].fileName = items[1].fileName.substr(0, length - 4) + "...";
    //         return this.computeSelectItems(items);
    //     }
    //     if (items.length === 3) {
    //         if (items[1]?.placeholder) {
    //             let length = items[2].fileName.length;
    //             items[2].fileName = items[2].fileName.substr(0, length - 4) + "...";
    //             return this.computeSelectItems(items);
    //         }
    //     }
    //     if (items[1]?.placeholder) {
    //         items.splice(2, 1);
    //         return this.computeSelectItems(items);
    //     }
    //     const e = items[1];
    //     e.placeholder = true;
    //     return this.computeSelectItems(items);
    // },
    computeSelectItems(items) {
      const width = this.getSelectItemWidth(items);
      if (width <= this.breadCrumbContainerWidth) return items;
      if (items.length === 1) {
        //一个item，后边显示省略号
        let length = items[0].fileName.length;
        items[0].fileName = items[0].fileName.substr(0, length - 4) + "...";
        return this.computeSelectItems(items);
      }
      if (items.length === 2) {
        const item1W = this.getSelectItemWidth([items[1]]);
        if (item1W <= this.breadCrumbContainerWidth) {
          //最后的item宽度小于容器宽度
          const itemsW = this.getSelectItemWidth(items);
          if (itemsW <= this.breadCrumbContainerWidth) {
            return items;
          } else {
            const length = items[0].fileName.length;
            items[0].fileName = items[0].fileName.substr(0, length - 4) + "...";
            if (items[0].fileName === "...") {
              items[0].placeholder = true;
              const itemsW1 = this.getSelectItemWidth(items);
              if (itemsW1 < this.breadCrumbContainerWidth) {
                return items;
              } else {
                const length = items[1].fileName.length;
                items[1].fileName =
                items[1].fileName.substr(0, length - 4) + "...";
                return this.computeSelectItems(items);
              }
            } else {
              return this.computeSelectItems(items);
            }
          }
        } else {
          //最后的item宽度大于容器宽度
          items[0].placeholder = true;
          const length = items[1].fileName.length;
          items[1].fileName = items[1].fileName.substr(0, length - 4) + "...";
          return this.computeSelectItems(items);
        }
      }
      if (items.length >= 3) {
        // 优先保证最后一个展示全，如果最后一个展示不全，前边全部折叠
        // 如果最后一个展示全了，优先保证第一个展示全，中间折叠
        const lastItemW = this.getSelectItemWidth([items[items.length - 1]]);
        if (lastItemW <= this.breadCrumbContainerWidth) {
          const itemsW = this.getSelectItemWidth(items);
          if (itemsW <= this.breadCrumbContainerWidth) {
            return items;
          } else {
            let item0 = items[0];
            let lastItem = items[items.length - 1];
            let newArray = [item0, lastItem];
            let length = this.getSelectItemWidth(newArray);
            if (length <= this.breadCrumbContainerWidth) {
              let defaultW = this.computeFontSize(" ... ") + 26;
              length += defaultW;
              if (length <= this.breadCrumbContainerWidth) {
                // return items;
                //收尾长度小于容器宽度，中间优先展示尾部
                let itemsW = this.getSelectItemWidth(items);
                if (itemsW <= this.breadCrumbContainerWidth) {
                  return items;
                } else {
                  // let length = items[1].fileName.length;
                  // items[0].fileName =
                  // items[0].fileName.substr(0, length - 4) + '...';
                  let item1 = items[1];
                  if (item1.placeholder === true) {
                    items.splice(1, 1);
                    let item1 = items[1];
                    item1.placeholder = true;
                  } else {
                    item1.placeholder = true;
                  }
                  return this.computeSelectItems(items);
                }
              } else {
                //收尾大于容器宽度，中间省略
                items.map((item, index) => {
                  if (index !== 0 && index !== items.length - 1) {
                    items[index].placeholder = true;
                  }
                });
                const length = items[0].fileName.length;
                items[0].fileName =
                items[0].fileName.substr(0, length - 4) + "...";
                if (items[0].fileName === "...") {
                  items[0].placeholder = true;
                  items.splice(0, 1);
                }
                return this.computeSelectItems(items);
              }
            } else {
              // 尾部能展示全，首部展示不全，中间就省略
              items.map((item, index) => {
                if (index !== 0 && index !== items.length - 1) {
                  items[index].placeholder = true;
                }
              });
              const length = items[0].fileName.length;
              items[0].fileName =
              items[0].fileName.substr(0, length - 4) + "...";
              if (items[0].fileName === "...") {
                items[0].placeholder = true;
                items.splice(1, 1);
              }
              return this.computeSelectItems(items);
            }
          }
        } else {
          items.splice(1, 1);
          return this.computeSelectItems(items);
        }
      }
    },

    getSelectItemWidth(items) {
      let width = 0;
      for (let i = 0; i < items.length; i++) {
        let text = items[i]?.placeholder ? "..." : items[i].fileName;
        if (i == 0) {
          text = items[i].fileName;
        }
        width += this.computeFontSize(text);
      }
      if (items.length > 1) {
        let crumbWidth = (items.length - 1) * 30;
        width += crumbWidth;
      }
      return width;
    },
    removeObserveBreadCrumbWidth() {
      if (this.breadcrumbWidthObserver) {
        this.breadcrumbWidthObserver.disconnect();
      }
    }
  },
  mounted() {
    this.observeBreadCrumbWidth();
    const items = this.$el.querySelectorAll(".kb_breadcrumb__item");
    if (items.length) {
      items[items.length - 1].setAttribute("aria-current", "page");
    }
  },
  unmounted() {
    this.removeObserveBreadCrumbWidth();
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb_cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
}
.cloud_breadcrumb {
  position: relative;
  font-size: 12px;
  display: flex;
  flex-wrap: nowrap;

  .active {
    color: #a9aeae;
    font-size: 12px;
    font-weight: normal !important;
    height: 5px;
    cursor: pointer;

    &:hover {
      border-radius: 4px;
      color: #121317;
      cursor: pointer;
    }

    &:active {
      color: #121317;
    }

    span {
      svg {
        width: 16px;
      }
    }
  }

  .default {
    color: #121317;
    font-size: 12px;
    cursor: default !important;
    font-weight: normal !important;
  }
}
</style>

<style lang="scss">
.cloud_breadcrumb_popover {
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  top: 41px !important;
  padding: 0 !important;

  .file-separator {
    width: 16px !important;
    height: auto !important;
  }
}
</style>
